export default __webpack_public_path__ + "static/media/EnquireNowCarImage.6df1cfba.svg";